import Axios from "../../../networking/interceptor";

import { createAsyncThunk } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { pharmacy_read_messages } from "../../../networking/urlEndPoints";

export const readUnreadMessages = createAsyncThunk('readUnreadMessages', async (requestedData, { rejectWithValue }) => {
    try {
        const response = await Axios.post(pharmacy_read_messages, requestedData)

        const data = response.data;
        return data;
    } catch (error) {
        return rejectWithValue(error.response)
    }
})

const initialState = {
    loading: false,
    data: null,
    error: null
}

const readUnreadMessagesSlice = createSlice({
    name: 'readUnreadMessages',
    initialState,

    extraReducers: (builder) => {
        builder.addCase(readUnreadMessages.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null
            }
        })

        builder.addCase(readUnreadMessages.fulfilled.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            }
        })

        builder.addCase(readUnreadMessages.rejected.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            }
        })
    }

})

export default readUnreadMessagesSlice.reducer